import { Pipe, PipeTransform } from '@angular/core';
import { Learning_Type } from '@app/enums/learning-type.enum';

@Pipe({
  name: 'instructionTypeCustomHeader',
  standalone: false,
})
export class InstructionTypeCustomHeaderPipe implements PipeTransform {
  /**
   * Return transformed Learning Type string header to show or not show the custom header.
   * @param learningType - instruction type (learning type) to transform to new display type else empty string, if not shown.
   * @returns - transformed instruction (learning type) css name string
   */
  public transform(learningType: string): string {
    switch (learningType) {
      case Learning_Type.WEBINAR:
      case Learning_Type.QUICK_LEARNING:
      case Learning_Type.E_LEARNING:
        return 'elearning';
      case Learning_Type.CERTIFICATION_EXAM:
        return 'certification-exam';
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.VIRTUAL:
        return 'course';
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.IN_PERSON:
        return 'course';
      case Learning_Type.INSTRUCTOR_LED:
        return 'course';
      case Learning_Type.SELF_STUDY:
        return 'course';
      default:
        return 'course';
    }
  }
}
